import { useEffect } from "react";
import { useConfig } from "../../providers/useConfig";
const script = (token) => {
    const url = `https://www.google.com/recaptcha/api.js?render=${token}&badge=bottomleft`;
    const googleCodeElement = document.createElement("script");
    googleCodeElement.setAttribute("src", url);
    return googleCodeElement;
};
export const InsertGoogleRecaptcha = () => {
    const config = useConfig();
    useEffect(() => {
        const element = window?.document?.querySelector("html > head");
        if (element && config["X-RECAPTCHA-FEATURE-TOGGLE"] === "true") {
            element.appendChild(script(config["X-RECAPTCHA-ID"]));
        }
    }, []);
    return null;
};
//# sourceMappingURL=InsertGoogleRecaptcha.js.map